import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";

import { refreshAuthLogic } from "@/api/refresh.api.ts";

let cancel: (() => void) | undefined;

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API,
  // withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axios.defaults.withCredentials = true;

const storedAuth = localStorage.getItem("auth");

if (storedAuth !== null) {
  const auth = JSON.parse(storedAuth);

  apiClient.defaults.headers.common.authorization = `Bearer ${auth.state.userInfo.token}`;
}

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // const originalRequest = error.config;
    //
    // if (error.s === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   await refreshAuthLogic(error);
    //   return apiClient(originalRequest);
    // }
    return Promise.reject(error);
  },
);

createAuthRefreshInterceptor(apiClient, refreshAuthLogic, {
  statusCodes: [401],
  pauseInstanceWhileRefreshing: true,
});

export const setHeaderToken = (token: string) => {
  apiClient.defaults.headers.common.Authorization = `Bearer ${token}`;
};
export const cancelRequests = () => {
  if (cancel) {
    cancel();
    cancel = undefined;
  }
};
